// extracted by mini-css-extract-plugin
export var pageContainer = "_n-1";
export var settingsContent = "_n-0";